(function () {
  const U = window.TBX;
  const TB = window.TB;
  const LS_MODE = U.LS_MODE;
  const advanceSelection = U.advanceSelection;
  const allEntries = U.allEntries;
  const backlogShape = U.backlogShape;
  const cardEntry = U.cardEntry;
  const entryCard = U.entryCard;
  const entryName = U.entryName;
  const el = U.el;
  const entryKey = U.entryKey;
  const esc = U.esc;
  const fmtText = U.fmtText;
  const fmtTs = U.fmtTs;
  const matchesFilter = U.matchesFilter;
  const progress = U.progress;
  const render = U.render;
  const scriptStatus = U.scriptStatus;
  const setOf = U.setOf;
  const shapeLabel = U.shapeLabel;
  const verdictFor = U.verdictFor;
  const visibleCards = U.visibleCards;
  const FAIL_REASONS = U.FAIL_REASONS;
  const reasonLabel = U.reasonLabel;

  function renderRulesDrawer() {
    if (!TB.rules.open) return null;
    const drawer = el("div");
    drawer.id = "tbrules";
    const head = el("div", "tbruleshead");
    head.appendChild(el("span", "label", "Core rules"));
    const close = el("button", "btn", "✕");
    close.onclick = function () { TB.rules.open = false; render(); };
    head.appendChild(close);
    drawer.appendChild(head);

    const search = document.createElement("input");
    search.type = "text";
    search.placeholder = "Rule number (317.1) or text search…";
    search.value = TB.rules.query;
    search.id = "tbrulesq";
    search.onkeydown = function (ev) {
      if (ev.key === "Enter" && search.value.trim()) TB.searchRules(search.value.trim());
      ev.stopPropagation();
    };
    drawer.appendChild(search);

    if (TB.rules.title) drawer.appendChild(el("div", "tbrulestitle", esc(TB.rules.title)));
    const list = el("div", "tbruleslist");
    list.id = "tbruleslistbox";
    if (TB.rules.loading) {
      list.appendChild(el("div", "zlabel", "Loading…"));
    } else if (!TB.rules.entries.length) {
      list.appendChild(el("div", "zlabel", "No matches."));
    } else {
      for (const r of TB.rules.entries) {
        (function (r) {
          const depth = (r.rule.match(/\./g) || []).length;
          const row = el("div", "tbrule");
          row.style.paddingLeft = 8 + depth * 14 + "px";
          const numEl = el("span", "tbrulenum rref", esc(r.rule));
          numEl.setAttribute("data-rule", r.rule);
          row.appendChild(numEl);
          row.appendChild(el("span", "tbruletext", esc(r.text)));
          list.appendChild(row);
        })(r);
      }
    }
    drawer.appendChild(list);
    return drawer;
  }
  TB.renderRulesDrawer = renderRulesDrawer;

  document.addEventListener("click", function (ev) {
    const t = ev.target && ev.target.closest ? ev.target.closest(".rref") : null;
    if (t && t.getAttribute("data-rule")) {
      TB.lookupRule(t.getAttribute("data-rule"));
      const q = document.getElementById("tbrulesq");
      if (q) q.value = t.getAttribute("data-rule");
    }
  });

  function renderHead() {
    const head = el("div", "tbhead");
    const back = el("button", "btn", "‹ Menu");
    back.onclick = function () { location.href = "/"; };
    head.appendChild(back);
    head.appendChild(el("h1", "disp", "TESTBENCH"));

    const tabs = el("div", "tbtabs");
    for (const t of [["cards", "Cards"], ["coverage", "Coverage"]]) {
      (function (t) {
        const b = el("button", "btn" + (TB.tab === t[0] ? " primary" : ""), t[1]);
        b.onclick = function () { TB.tab = t[0]; render(); };
        tabs.appendChild(b);
      })(t);
    }
    head.appendChild(tabs);

    if (TB.tab === "cards") {
      const p = progress();
      const wrap = el("div", "tbprog");
      const bar = el("div", "tbprogbar");
      for (const seg of [["pass", p.pass], ["fail", p.fail]]) {
        if (!seg[1] || !p.total) continue;
        const s = el("div", "tbseg tbseg-" + seg[0]);
        s.style.width = (100 * seg[1] / p.total) + "%";
        bar.appendChild(s);
      }
      wrap.appendChild(bar);
      wrap.appendChild(el("div", "tbprogtxt",
        p.pass + " pass · " + p.fail + " fail · " + p.todo + " to go"));
      head.appendChild(wrap);
    }

    const rulesBtn = el("button", "btn" + (TB.rules.open ? " primary" : ""), "Rules");
    rulesBtn.onclick = function () {
      TB.rules.open = !TB.rules.open;
      render();
      const q = document.getElementById("tbrulesq");
      if (q) q.focus();
    };
    head.appendChild(rulesBtn);

    const dot = el("div", "tbdot " + (TB.online ? "on" : "off"));
    dot.title = TB.online ? "Server connected" : "Server offline";
    head.appendChild(dot);
    return head;
  }

  function renderList() {
    const side = el("div", "tblist");
    const search = window.UIX.searchField({
      id: "tbsearch",
      placeholder: "Filter name / text… (Esc clears)",
      value: TB.search,
      onInput: function (value) {
        TB.search = value;
        render();
      },
    });
    search.onkeydown = function (ev) {
      if (ev.key === "Escape" && search.value) {
        TB.search = "";
        render();
        const s = document.getElementById("tbsearch");
        if (s) s.focus();
        ev.stopPropagation();
      } else if (ev.key === "Enter") {
        const vis = visibleCards();
        if (vis.length === 1) {
          TB.sel = entryKey(vis[0]);
          const sc = vis[0].scenario || { title: "Basic play", spec: {} };
          TB.launch(vis[0], sc);
        }
        ev.stopPropagation();
      }
    };
    side.appendChild(search);

    const all = allEntries();
    const filters = el("div", "tbfilters");
    const chips = el("div", "tbchips");
    for (const f of [["all", "All"], ["todo", "To test"], ["fail", "Failed"], ["pass", "Passed"]]) {
      (function (f) {
        const n = all.filter(function (e2) { return matchesFilter(e2, f[0]); }).length;
        const c = el("button", "tbchip" + (TB.filter === f[0] ? " on" : ""),
          f[1] + " <span class='tbchipn'>" + n + "</span>");
        c.onclick = function () { TB.filter = f[0]; render(); };
        chips.appendChild(c);
      })(f);
    }
    filters.appendChild(chips);
    const modes = el("div", "tbchips tbmodes");
    for (const m of [["cards", "Cards"], ["list", "List"]]) {
      (function (m) {
        const b = el("button", "tbchip" + (TB.mode === m[0] ? " on" : ""), m[1]);
        b.onclick = function () {
          TB.mode = m[0];
          try { localStorage.setItem(LS_MODE, m[0]); } catch (e) { }
          render();
        };
        modes.appendChild(b);
      })(m);
    }
    filters.appendChild(modes);
    side.appendChild(filters);

    const vis = visibleCards();
    const select = function (entry) { TB.sel = entryKey(entry); render(); };
    const launchFirst = function (entry) {
      const sc = entry.scenario || { title: "Basic play", spec: {} };
      TB.launch(entry, sc);
    };
    const setHeader = function (set, count) {
      const folded = !!TB.folds[set];
      const meta = TB.sets.find(function (b) { return b.id === set; });
      const h = el("div", "tbsethead" + (folded ? " folded" : ""),
        "<span class='tbsetarrow'>" + (folded ? "▸" : "▾") + "</span> " +
        esc((meta && meta.title) || set) +
        "<span class='tbsetcount'>" + count + "</span>");
      h.title = folded ? "Click to expand" : "Click to collapse";
      h.onclick = function () { TB.toggleFold(set); };
      return h;
    };

    const list = el("div", "tbrows" + (TB.mode === "cards" ? " tbgridwrap" : ""));
    list.id = "tbrowsbox";
    let lastSet = null;
    let grid = null;
    const perSet = {};
    for (const entry of vis) perSet[setOf(entry)] = (perSet[setOf(entry)] || 0) + 1;
    for (const entry of vis) {
      const c = entryCard(entry);
      const set = setOf(entry);
      if (set !== lastSet) {
        lastSet = set;
        list.appendChild(setHeader(set, perSet[set]));
        if (TB.mode === "cards") {
          grid = el("div", "tbgrid");
          list.appendChild(grid);
        }
      }
      if (TB.folds[set]) continue;
      const v = verdictFor(entry);
      const st = scriptStatus(c);
      if (TB.mode === "cards") {
        (function (entry, c, v) {
          const cell = el("div", "tbcell" + (TB.sel === entryKey(entry) ? " sel" : ""));
          if (TB.sel === entryKey(entry)) cell.id = "tbrowsel";
          if (RB.hasArt(c)) {
            const img = document.createElement("img");
            img.loading = "lazy";
            img.decoding = "async";
            img.alt = entryName(entry);
            RB.artSrc(img, c, "150px");
            RB.artFallback(img, c, function () {
              img.remove(); cell.classList.add("noimg"); cell.appendChild(el("div", "tbcellname", esc(entryName(entry))));
            });
            cell.appendChild(img);
          } else {
            cell.classList.add("noimg");
            cell.appendChild(el("div", "tbcellname", esc(entryName(entry))));
          }
          cell.appendChild(el("span", "tbcellstat tbstat " + (v ? v.verdict : "todo")));
          cell.title = entryName(entry) + " — " + (v ? v.verdict : "to test") +
            "\nClick to select · double-click or Enter to launch";
          cell.onclick = function () { select(entry); };
          cell.ondblclick = function () { launchFirst(entry); };
          grid.appendChild(cell);
        })(entry, c, v);
      } else {
        (function (entry, c, v, st) {
          const row = el("div", "tbrow" + (TB.sel === entryKey(entry) ? " sel" : ""));
          if (TB.sel === entryKey(entry)) row.id = "tbrowsel";
          row.appendChild(el("span", "tbstat " + (v ? v.verdict : "todo")));
          row.appendChild(el("span", "tbrcost", c && c.energy !== undefined && c.energy !== null ? String(c.energy) : "—"));
          row.appendChild(el("span", "tbrname", esc(entryName(entry))));
          if (c) {
            const chip = el("span", "tbscript tbscript-" + st[0], st[0]);
            chip.title = st[1];
            row.appendChild(chip);
          }
          row.title = "Click to select · double-click or Enter to launch";
          row.onclick = function () { select(entry); };
          row.ondblclick = function () { launchFirst(entry); };
          list.appendChild(row);
        })(entry, c, v, st);
      }
    }
    if (!vis.length) list.appendChild(el("div", "zlabel tbempty", "No cards match."));
    side.appendChild(list);
    return side;
  }

  function renderDetail() {
    const main = el("div", "tbmain");
    main.id = "tbmainbox";
    const entry = cardEntry(TB.sel);
    if (!entry) {
      main.appendChild(el("div", "zlabel tbempty", "Select a card on the left."));
      return main;
    }
    const c = entryCard(entry);

    const top = el("div", "tbcard");
    if (RB.hasArt(c)) {
      const imgwrap = el("div", "tbimg");
      const img = document.createElement("img");
      RB.artSrc(img, c, "380px");
      img.alt = entryName(entry);
      RB.artFallback(img, c);
      imgwrap.appendChild(img);
      top.appendChild(imgwrap);
    }

    const info = el("div", "tbinfo");
    info.appendChild(el("h2", "disp", esc(entryName(entry))));
    const smeta = TB.sets.find(function (b) { return b.id === entry.__set; });
    info.appendChild(el("div", "tbsettag", esc((smeta && smeta.title) || entry.__set)));
    if (c) {
      const line = (c.supertypes || []).concat(c.types || []).join(" ") +
        ((c.tags || []).length ? " — " + c.tags.join(", ") : "");
      info.appendChild(el("div", "tbtypeline", esc(line) +
        (c.domains ? " · " + esc(c.domains.join("/")) : "") +
        (c.energy !== undefined && c.energy !== null ? " · " + c.energy + "⚡" : "") +
        (c.might !== undefined && c.might !== null ? " · " + c.might + " might" : "")));
      info.appendChild(el("div", "tbtext", fmtText(c.text)));
      const st = scriptStatus(c);
      info.appendChild(el("div", "tbscriptline",
        "Engine status: <span class='tbscript tbscript-" + st[0] + "'>" + st[0] + "</span> — " + esc(st[1])));
    }

    if (entry.expected) {
      const exp = el("div", "tbexpected");
      exp.appendChild(el("div", "label", "Expected behavior"));
      exp.appendChild(el("div", null, fmtText(entry.expected)));
      info.appendChild(exp);
    }

    const scen = el("div", "tbscenarios");
    scen.appendChild(el("div", "label", "Scenario"));
    const sc = entry.scenario || { title: "Basic play", spec: {} };
    const row = el("div", "tbscen");
    const btn = el("button", "btn primary", "Launch\u00a0▸");
    btn.onclick = function () { TB.launch(entry, sc); };
    row.appendChild(btn);
    const txt = el("div", "tbscentxt");
    txt.appendChild(el("div", "tbscentitle", esc(sc.title || "Scenario")));
    if (sc.notes) txt.appendChild(el("div", "tbscennotes", fmtText(sc.notes)));
    row.appendChild(txt);
    scen.appendChild(row);
    info.appendChild(scen);

    if (TB.canRecord) {
      const quick = el("div", "tbquick");
      quick.appendChild(el("div", "label", "Verdict without launching"));
      const picked = [];
      const reasons = el("div", "tbreasons");
      for (const r of FAIL_REASONS) {
        (function (r) {
          const b = el("button", "tbreason", esc(r.label));
          b.title = r.hint;
          b.onclick = function () {
            const i = picked.indexOf(r.k);
            if (i < 0) picked.push(r.k); else picked.splice(i, 1);
            b.className = "tbreason" + (picked.indexOf(r.k) >= 0 ? " on" : "");
          };
          reasons.appendChild(b);
        })(r);
      }
      quick.appendChild(reasons);
      const noteEl = document.createElement("input");
      noteEl.type = "text";
      noteEl.placeholder = "Optional note…";
      quick.appendChild(noteEl);
      const btns = el("div", "tbverdicts");
      for (const v of [["pass", "Pass"], ["fail", "Fail"]]) {
        (function (v) {
          const b = el("button", "btn tbv-" + v[0], v[1]);
          b.onclick = function () {
            TB.submit(entry.__set, entry.card, v[0], noteEl.value, null, null, picked).then(function () {
              advanceSelection();
              render();
            }).catch(function () { render(); });
          };
          btns.appendChild(b);
        })(v);
      }
      quick.appendChild(btns);
      info.appendChild(quick);
    }

    const hist = (TB.feedback[entry.__set] && TB.feedback[entry.__set][entry.card]) || [];
    if (hist.length) {
      const h = el("div", "tbhist");
      h.appendChild(el("div", "label", "History"));
      for (const e2 of hist.slice().reverse()) {
        const tags = (e2.tags || []).map(function (k) {
          return "<span class='tbtag'>" + esc(reasonLabel(k)) + "</span>";
        }).join("");
        h.appendChild(el("div", "tbhistrow",
          "<span class='tbstat " + esc(e2.verdict) + "'></span> " + esc(e2.verdict) +
          (e2.scenario ? " · " + esc(e2.scenario) : "") + tags +
          (e2.note ? " — " + esc(e2.note) : "") +
          "<span class='tbhistts'>" + esc(fmtTs(e2.ts)) + "</span>"));
      }
      info.appendChild(h);
    }

    top.appendChild(info);
    main.appendChild(top);
    return main;
  }

  function uniqueShapes(lines) {
    const seen = {};
    const out = [];
    for (const line of lines) {
      const k = backlogShape(line);
      if (seen[k]) continue;
      seen[k] = line;
      out.push(k);
    }
    return { keys: out, sample: seen };
  }

  function coverageData() {
    const sets = {};
    for (const c of window.CARD_DB) {
      if (c.token) continue;
      const t = c.types || [];
      if (t.indexOf("rune") >= 0) continue;
      const s = sets[c.set] = sets[c.set] || { set: c.set, total: 0, scripted: 0, manual: 0, cards: [] };
      s.total++;
      const info = scriptStatus(c);
      const st = info[0];
      if (st === "scripted") s.scripted++;
      else s.manual++;
      const lines = info[2] || [];
      const shapes = uniqueShapes(lines);
      s.cards.push({ c: c, st: st, set: s.set, lines: lines, shapes: shapes.keys, shapeLine: shapes.sample });
    }
    return Object.keys(sets).sort().map(function (k) { return sets[k]; });
  }

  const COV_KINDS = [
    { k: "scripted", label: "Scripted" },
    { k: "manual", label: "Manual fallback" }
  ];

  function shapeTally(cards) {
    const counts = {};
    for (const item of cards) {
      if (item.st === "scripted") continue;
      for (const k of item.shapes) counts[k] = (counts[k] || 0) + 1;
    }
    return Object.keys(counts).sort(function (a, b) {
      return counts[b] - counts[a] || (a < b ? -1 : a > b ? 1 : 0);
    }).map(function (k) { return { k: k, n: counts[k] }; });
  }

  function covBar(s) {
    const bar = el("div", "covbar");
    for (const kind of COV_KINDS) {
      const n = s[kind.k] || 0;
      if (!n) continue;
      const seg = el("div", "covseg cov-" + kind.k);
      seg.style.flexGrow = String(n);
      seg.title = kind.label + ": " + n + " / " + s.total;
      bar.appendChild(seg);
    }
    if (!s.total) bar.appendChild(el("div", "covseg cov-empty"));
    return bar;
  }

  function covLegend() {
    const leg = el("div", "covlegend");
    for (const kind of COV_KINDS) {
      const it = el("span", "covlegitem");
      it.appendChild(el("i", "covdot cov-" + kind.k));
      it.appendChild(el("span", null, esc(kind.label)));
      leg.appendChild(it);
    }
    return leg;
  }

  function renderCoverage() {
    const main = el("div", "tbmain tbcov");
    const data = coverageData();

    const all = { total: 0, scripted: 0, manual: 0 };
    for (const s of data) {
      all.total += s.total; all.scripted += s.scripted; all.manual += s.manual;
    }
    const allPct = all.total ? Math.round(100 * all.scripted / all.total) : 0;

    const sum = el("div", "covsum");
    const head = el("div", "covsumhead");
    const left = el("div", null);
    left.appendChild(el("div", "label", "Script coverage"));
    left.appendChild(el("div", "covsumsub",
      all.total + " cards across " + data.length + " set" + (data.length === 1 ? "" : "s")));
    head.appendChild(left);
    const big = el("div", "covsumpct");
    big.appendChild(el("span", "covsumnum", String(allPct)));
    big.appendChild(el("span", "covsumunit", "% scripted"));
    head.appendChild(big);
    sum.appendChild(head);
    sum.appendChild(covBar(all));
    const stats = el("div", "covstats");
    for (const kind of COV_KINDS) {
      const it = el("div", "covstat");
      it.appendChild(el("i", "covdot cov-" + kind.k));
      it.appendChild(el("span", "covstatn", String(all[kind.k])));
      it.appendChild(el("span", "covstatl", esc(kind.label)));
      stats.appendChild(it);
    }
    sum.appendChild(stats);
    main.appendChild(sum);

    const cols = el("div", "covcols");

    const list = el("div", "covsets");
    for (const s of data) {
      (function (s) {
        const pct = s.total ? Math.round(100 * s.scripted / s.total) : 0;
        const card = el("div", "covset" + (TB.covSet === s.set ? " sel" : ""));
        const top = el("div", "covsettop");
        top.appendChild(el("div", "covsetname", esc(s.set)));
        top.appendChild(el("div", "covsetpct", pct + "%"));
        card.appendChild(top);
        card.appendChild(covBar(s));
        const meta = el("div", "covsetmeta");
        meta.appendChild(el("span", "covsetcount", s.total + " cards"));
        for (const kind of COV_KINDS) {
          if (!s[kind.k]) continue;
          const chip = el("span", "covchip cov-" + kind.k, String(s[kind.k]));
          chip.title = kind.label;
          meta.appendChild(chip);
        }
        card.appendChild(meta);
        card.onclick = function () {
          TB.covSet = TB.covSet === s.set ? null : s.set;
          TB.covShape = null;
          render();
        };
        list.appendChild(card);
      })(s);
    }
    cols.appendChild(list);

    const det = el("div", "tbcovdet");
    const s = TB.covSet ? data.find(function (x) { return x.set === TB.covSet; }) : null;
    const scoped = s ? s.cards : data.reduce(function (acc, x) { return acc.concat(x.cards); }, []);
    const dhead = el("div", "covdethead");
    dhead.appendChild(el("div", "covdettitle", esc(s ? s.set : "All sets")));
    const filters = el("div", "covfilters");
    const opts = [{ k: "manual", label: "Manual" }, { k: "scripted", label: "Scripted" },
      { k: "all", label: "All" }];
    for (const o of opts) {
      (function (o) {
        const b = el("button", "covfilter" + (TB.covFilter === o.k ? " on" : ""), esc(o.label));
        b.onclick = function () { TB.covFilter = o.k; TB.covShape = null; render(); };
        filters.appendChild(b);
      })(o);
    }
    dhead.appendChild(filters);
    det.appendChild(dhead);

    const tools = el("div", "covtools");
    const search = document.createElement("input");
    search.type = "text";
    search.className = "covsearch";
    search.placeholder = "Filter by card name or id…";
    search.value = TB.covQuery || "";
    search.oninput = function () {
      TB.covQuery = search.value;
      const q = search.value.trim().toLowerCase();
      for (const row of det.querySelectorAll(".tbcovcard")) {
        row.style.display = (!q || row.dataset.k.indexOf(q) >= 0) ? "" : "none";
      }
    };
    tools.appendChild(search);

    const shapes = shapeTally(scoped);
    const pick = document.createElement("select");
    pick.className = "covshapesel";
    pick.title = "Show only the cards blocked on one kind of ability";
    pick.disabled = TB.covFilter !== "manual";
    const anyOpt = document.createElement("option");
    anyOpt.value = "";
    anyOpt.textContent = "Blocked on: anything (" + scoped.filter(function (x) {
      return x.st !== "scripted";
    }).length + ")";
    pick.appendChild(anyOpt);
    for (const sh of shapes) {
      const opt = document.createElement("option");
      opt.value = sh.k;
      opt.textContent = shapeLabel(sh.k) + " (" + sh.n + ")";
      if (TB.covShape === sh.k) opt.selected = true;
      pick.appendChild(opt);
    }
    if (TB.covShape && !shapes.some(function (sh) { return sh.k === TB.covShape; })) TB.covShape = null;
    pick.value = TB.covShape || "";
    pick.onchange = function () {
      TB.covShape = pick.value || null;
      render();
    };
    tools.appendChild(pick);
    det.appendChild(tools);

    const cards = el("div", "tbcovlist");
    const q = (TB.covQuery || "").trim().toLowerCase();
    let shown = 0;
    for (const item of scoped) {
      const st = item.st === "error" ? "manual" : item.st;
      if (TB.covFilter !== "all" && st !== TB.covFilter) continue;
      if (TB.covShape && item.shapes.indexOf(TB.covShape) < 0) continue;
      shown++;
      const row = el("div", "tbcovcard");
      row.dataset.k = (item.c.name + " " + item.c.id).toLowerCase();
      if (q && row.dataset.k.indexOf(q) < 0) row.style.display = "none";
      const top = el("div", "tbcovrow");
      top.appendChild(el("i", "covdot cov-" + st));
      top.appendChild(el("span", "tbcovname", esc(item.c.name)));
      if (!s) top.appendChild(el("span", "covchip", esc(item.set)));
      top.appendChild(el("span", "tbcovid", esc(item.c.id)));
      if (item.st === "error") top.appendChild(el("span", "covchip cov-error", "error"));
      row.appendChild(top);
      const why = (TB.covShape && item.shapeLine[TB.covShape]) || item.lines[0];
      if (why) {
        const line = el("div", "tbcovwhy", fmtText(why));
        line.title = item.lines.join("\n");
        row.appendChild(line);
      }
      cards.appendChild(row);
    }
    if (!shown) cards.appendChild(el("div", "zlabel", "None in this category."));
    det.appendChild(cards);
    det.appendChild(covLegend());
    cols.appendChild(det);
    main.appendChild(cols);
    return main;
  }

  Object.assign(U, { renderRulesDrawer: renderRulesDrawer, renderHead: renderHead, renderList: renderList, renderDetail: renderDetail, coverageData: coverageData, shapeTally: shapeTally, renderCoverage: renderCoverage });
})();
